import React from 'react';
import CustomExpandableTable from '../../../../../../../components/table/CustomExpandableTable';
import NotInformation from '../../../../../../../components/NotInformation';
import PayrollUserHistoryTableApp from '../Functionality/PayrollUserHistoryTableApp';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PayrollUserHistoryTable = ({ id }) => {
    const {
        t,
        history,
        columns,
        pagination,
        rowsPerPage,
        handleRowExpand,
        renderExpandedRow,
    } = PayrollUserHistoryTableApp({ id });

    return <div className={"col-12 mt-2"}>
        {history.length > 0 ? (
            <>
                <CustomExpandableTable
                    id='tbl_pud_history'
                    columns={columns}
                    rows={history}
                    renderExpandedRow={renderExpandedRow}
                    onRowExpand={handleRowExpand}
                    checkbox={false}
                    rowsPerPage={rowsPerPage}
                />
                {pagination?.()}
            </>
            ) : (
                <NotInformation
                    className={"mt-4"}
                    card={true}
                    text={t('no_records_available')}
                />
            )
        }
    </div>
};

export default PayrollUserHistoryTable;
